<template>
  <v-container fluid grid-list-md>
    <v-tabs grow v-model="tab" v-if="broker">
      <!-- <v-tabs-slider color="primary"></v-tabs-slider> -->

      <v-tab>
        <v-icon style="margin-right:10px">medical_services</v-icon>
        {{ $t("views.guides.health_reasonable_&_customary_guides") }}
      </v-tab>
      <v-tab>
        <v-icon style="margin-right:10px">mdi-tooth</v-icon>
        {{ $t("views.guides.dental_fee_guides") }}
      </v-tab>
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <plan-guides-assignments-table :brokerId="broker.Id" v-if="tab==0" coverage="Health"/>
        </v-tab-item>
        <v-tab-item>
          <plan-guides-assignments-table :brokerId="broker.Id" v-if="tab==1" coverage="Dental"/>
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
    <div v-else>
    <v-row justify="center">
      <v-progress-circular
        :size="70"
        :width="7"
        color="purple"
        indeterminate
      ></v-progress-circular>
    </v-row>
  </div>
    <error-handler :error="error"></error-handler>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ErrorHandler from "@/components/ErrorHandler";
import PlanGuidesAssignmentsTable from "../components/Guides/PlanGuidesAssignmentsTable.vue";

export default {
  components: {
    ErrorHandler,
    PlanGuidesAssignmentsTable,
  },
  data() {
    return {
      tab: null,
      error: null,
      broker: null,
    };
  },
  watch: {
    tab:{
      handler(V) {
        console.log(V);
      }
    },
  },
  async mounted() {
    console.log("mounted: ", this.$route.params.broker);
    try {
      this.broker = (await this.getOrganizationById({
        id: this.$route.params.broker,
      })).data;
    } catch (error) {
      this.error = error;
    }
  },
  methods: {
    ...mapActions("plansMembers", ["getOrganizationById"]),
  },
};
</script>
